module.exports = __webpack_public_path__ + "img/image (51).300e884c.jpg";